module.exports = __webpack_public_path__ + "static/media/aziz.fd8aad1f.webp";